import { render, staticRenderFns } from "./modalRechazarAnuncio.vue?vue&type=template&id=133850fb&scoped=true"
import script from "./modalRechazarAnuncio.vue?vue&type=script&lang=js"
export * from "./modalRechazarAnuncio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133850fb",
  null
  
)

export default component.exports